import * as React from 'react';
const SvgAppDevelopment = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m16.32 121.545 4.284-38.25c1.266-6.802 6.45-12.19 13.175-13.706l19.777-4.448M70.455 65.135l19.773 4.448a17.289 17.289 0 0 1 13.18 13.707l4.278 38.25M54.426 57.113l-.636 6.056a5.72 5.72 0 0 0 .31 2.59c1.013 2.865 4.208 4.989 8.033 4.989 3.535 0 6.532-1.818 7.763-4.361a5.78 5.78 0 0 0 .605-2.462c0-.245 0-.5-.03-.756l-.647-6.133M43.189 31.354l-.346-.72c-.855-1.788-1.384-3.723-1.435-5.7v-.357c0-5.842 3.632-11.322 9.447-13.375l.447-1.761A9.693 9.693 0 0 1 54.1 4.737a9.623 9.623 0 0 1 4.889-2.43A20.341 20.341 0 0 1 73.97 5.54a20.52 20.52 0 0 1 8.876 15.238"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.093 22.187a13.411 13.411 0 0 0 9.131 1.583l4.37-.801c.33-.062.666-.092.997-.092a5.529 5.529 0 0 1 4.756 2.722c.509.852.773 1.833.773 2.824v14.421c0 3.054-1.094 6.006-3.077 8.32l-3.047 3.549a12.678 12.678 0 0 1-9.62 4.427 12.668 12.668 0 0 1-9.62-4.427l-3.046-3.55a12.782 12.782 0 0 1-3.078-8.319l-.035-4.233M51.587 14.21l-.733-3.013M32.821 105.571l-1.388-24.272c-.056-.884.508-1.64 1.225-1.64h59.35c.717 0 1.281.756 1.225 1.64l-1.388 24.272M2 122h120M28.345 111.924H96.32v4.944c0 2.829-2.29 5.127-5.107 5.127H33.452c-2.818 0-5.107-2.298-5.107-5.127v-4.944Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m53.555 89.408-6.77 6.644 6.77 6.644M71.106 89.408l6.77 6.644-6.77 6.644M66.7 85.757l-8.658 20.591"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgAppDevelopment;
